

<div class="dialog-header">
    <h2>Mapping Details</h2>
    <button mat-icon-button (click)="closeDialog()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-box">
  <div class="dialog-content">
    <div class="section">
      <p><strong>Filename :</strong> {{ filename }}</p>
      <hr />
    </div>
  
    <div class="section">
      <p><strong>User Story :</strong> {{ userStory }}</p>
      <hr />
    </div>
  
    <div class="section">
      <p><strong>Test Case :</strong> {{ testCase }}</p>
      <hr />
    </div>
  
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="methodName">
          <th mat-header-cell *matHeaderCellDef> Method Name </th>
          <td mat-cell *matCellDef="let element"> {{ element.methodName }} </td>
        </ng-container>
  
        <ng-container matColumnDef="codeSnippet">
          <th mat-header-cell *matHeaderCellDef> Code Snippet </th>
          <td mat-cell *matCellDef="let element">
            <app-code-snippet [code]="element.codeSnippet"></app-code-snippet>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  
    <div class="dialog-actions">
      <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
    </div>
  </div>
</div>
